/* global tinymce:true */

/* eslint-disable */

(function(tinymce)
{
    "use strict";
    var PluginManager = tinymce.PluginManager;

    function Plugin(editor)
    {
        function isTable()
        {
            return editor.dom.getParent(editor.selection.getStart(), 'table');
        }

        function addButtons()
        {
            editor.addButton('tabletools_props', {
                title: 'Table properties',
                icon: 'table',
                onclick: editor.menuItems.tableprops.onclick
            });
            editor.addButton('tabletools_delete', {
                title: 'Delete table',
                icon: 'remove',
                cmd: 'mceTableDelete'
            });
            editor.addButton("tabletools_cell", {
                type: "menubutton",
                title: "Cell",
                icon: 'template',
                menu: editor.menuItems.cell.menu
            });
            editor.addButton("tabletools_row", {
                type: "menubutton",
                title: "Row",
                icon: 'pagebreak',
                menu: editor.menuItems.row.menu
            });
            editor.addButton("tabletools_column", {
                type: "menubutton",
                title: "Column",
                icon: 'pagebreak fa-rotate-90',
                menu: editor.menuItems.column.menu
            });
            editor.addButton("tabletools_insert", {
                type: "menubutton",
                title: "Insert table",
                icon: 'table',
                ariaHideMenu: true,
                onclick: editor.menuItems.inserttable.onclick,
                onshow: editor.menuItems.inserttable.onshow,
                onhide: editor.menuItems.inserttable.onhide,
                menu: editor.menuItems.inserttable.menu
            });
        }

        function addToolbars()
        {
            editor.addContextToolbar(
                isTable,
                "tabletools_props tabletools_delete | tabletools_cell tabletools_row tabletools_column"
            );
        }

        addButtons();
        addToolbars();
    }

    PluginManager.add('tabletools', Plugin, ['table']);
    
})(tinymce);
